export const HISTORY_CATEGORIES = [
  "default",
  "last message",
  "last client message",
  "last consultant message",
  "client name",
  "paid status",
];

export const PAID_STATUSES = {
  gold: 3,
  silver: 2,
  bronze: 1,
  default: 0,
};
